import { PageHeader } from "@/components/AppLayout";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import FabricationCalculator from "@/components/FabricationCalculator";

export default function FabricationCalculatorPage() {
  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #fab-print-area, #fab-print-area * { visibility: visible !important; }
          #fab-print-area { position: absolute; left: 0; top: 0; width: 100%; padding: 0 !important; }
          .fab-no-print { display: none !important; }
        }
      `}</style>
      <PageHeader
        title="Fabrication Calculator"
        subtitle="Size balustrades, staircases, gates, steel/alloy frames, slat panels and glass — auto material take-off, cost estimate and a printable blueprint spec sheet."
        breadcrumb={["Operations", "Fabrication", "Calculator"]}
        actions={
          <Button data-testid="fab-print-btn" onClick={() => window.print()} className="rounded-sm h-10 bg-cyan-600 hover:bg-cyan-700 text-white">
            <Printer size={16} className="mr-2" /> Print spec sheet
          </Button>
        }
      />
      <div className="px-4 sm:px-6 lg:px-10 py-4 sm:py-6" id="fab-print-area">
        <FabricationCalculator />
      </div>
    </div>
  );
}
